import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Grid } from 'semantic-ui-react';

import { ManagementMeal } from 'components';
import * as cp_action from 'actions/company';
import * as cm_action from 'actions/commons';

import { Commons } from 'components';
import storage from 'helpers/storage';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';
import { safeHistoryPush } from 'helpers/pathValidator';

const propTypes = {};

const defaultProps = {};

class StaffManagementMeal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagerow: null,
      param: {
        keyword: null,
        orgCode: null,
        groupid: null,
        viewType: 'all'
      },
      isChecked: false,
      staffCheckedData: [],
      isLoadingBar: false,
      tabType: 'division',
      userTotal: 0,
      userCnt: 0,
      changeInfoParams: null
    };
  }
  async componentWillMount() {
    const { param, userTotal } = this.state;
    this.staffSel(param);

    const { divisionUserCnt } = this.props;
    if (divisionUserCnt && userTotal === 0) {
      let cnt = 0;
      divisionUserCnt.forEach((item) => {
        cnt += item.userCnt;
      });
      if (cnt > userTotal) {
        await this.setState({
          userTotal: cnt
        });
      }
    }
    this.sikdaeGroupSel(); //식대그룹 조회
    this.positionSel(); //직위 조회
  }

  componentDidMount() {
    cm.mainTitle('예산 관리');
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { text } = this.props;
    const { text: nText } = nextProps;

    return !(text !== nText);
  }

  isLoadingBarChange = async (isShow) => {
    await this.setState({ isLoadingBar: isShow });
  };

  staffDivisionSel = async () => {
    const { cmAPI } = this.props;
    const params = { viewType: 'all' };

    try {
      await cmAPI.staffDivisionSel(params);

      const { staffDivisionList } = this.props;

      if (staffDivisionList && staffDivisionList.data) {
        const { division, depth } = staffDivisionList.data;
        const navi = await cm.divisionNavigation(division);

        cm.staffDivisionNavigation(depth, navi);
      }
    } catch (e) {
      const response = e.response;

      if (response) {
        console.log('###### staffDivision call error : ', e);
      }
    }
  };

  //부서 수정
  divisionMod = async (params) => {
    try {
      const { cpAPI } = this.props;
      const { param } = this.state;

      if (!params['id']) {
        params['id'] = param.orgCode;
      }

      await cpAPI.divisionMod(params);
      this.staffDivisionSel();
      // return true;
    } catch (e) {
      let response = e.response;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
    }
  };

  //부서 삭제
  divisionDel = async () => {
    try {
      const { cpAPI } = this.props;
      const { param } = this.state;
      const params = {
        id: param.orgCode
      };

      await cpAPI.divisionDel(params);
      this.staffDivisionSel();
      // return true;
    } catch (e) {
      let response = e.response;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### divisionSortDel error : ', e);
    } finally {
    }
  };

  //부서 추가
  divisionAdd = async (params) => {
    try {
      const { cpAPI } = this.props;

      await cpAPI.divisionAdd(params);
      this.staffDivisionSel();
      // return true;
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### divisionAdd error : ', e);
    } finally {
    }
  };

  //식대그룹 조회
  sikdaeGroupSel = async () => {
    // this.isLoadingBarChange(true);
    const { param } = this.state;
    const { cmAPI } = this.props;
    const params = { viewType: param.viewType };

    try {
      await cmAPI.sikdaeGroupSel(params);
    } catch (e) {
      let response = e.response;
      if (response && response.data) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### sikdaeGroupSel Error : ', e);
    } finally {
      // this.isLoadingBarChange(false);
    }
  };

  //직위 조회
  positionSel = async () => {
    // this.isLoadingBarChange(true);
    const { cpAPI } = this.props;

    try {
      await cpAPI.positionSel();
    } catch (e) {
      console.log('###### positionSel Error : ', e);
    } finally {
      // this.isLoadingBarChange(false);
    }
  };

  //직위 등록
  positionAdd = async () => {
    try {
      let dom = document.getElementById('position-name');
      const { cpAPI } = this.props;

      const params = {
        name: dom.value
      };

      if (params.name.length > 10) {
        toastr('top-right', 'warning', '10자 이하로 입력해주세요.');
        return;
      } else {
        await cpAPI.positionAdd(params);
        this.positionSel();
      }
    } catch (e) {
      let response = e.response;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### PositionAdd error : ', e);
    } finally {
    }
  };

  //직위 수정
  positionMod = async (id) => {
    try {
      let dom = document.getElementById(id);
      const { cpAPI } = this.props;
      const params = {
        name: dom.value,
        id: id
      };

      if (params.name.length > 10) {
        toastr('top-right', 'warning', '10자 이하로 입력해주세요.');
        return;
      } else {
        await cpAPI.positionMod(params);
        this.positionSel();
      }
    } catch (e) {
      let response = e.response;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### positionMod error : ', e);
    } finally {
    }
  };

  //직위 삭제
  positionDel = async (params) => {
    try {
      const { cpAPI } = this.props;
      await cpAPI.positionDel(params);

      this.positionSel();
    } catch (e) {
      let response = e.response;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### positionDel error : ', e);
    } finally {
    }
  };

  //사용자 조회
  staffSel = async (params) => {
    this.isLoadingBarChange(true);
    const { cmAPI } = this.props;
    const { totalCount } = this.state;

    try {
      params['type'] = 'all';
      await cmAPI.staffSel(params);
      const { staffList } = this.props;
      if (staffList && staffList.data) {
        const { paging } = staffList.data;

        await this.setState({
          userCnt: paging.totalcount
        });
      }

      this.isLoadingBarChange(false);
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### staffSel error : ', e);
    } finally {
    }
  };
  //부서별 사용자 카운트
  divisionUserCntSel = async (params) => {
    // this.isLoadingBarChange(true);
    const { cpAPI } = this.props;
    const { userTotal } = this.state;
    try {
      await cpAPI.divisionUserCntSel(params);
      const { divisionUserCnt } = this.props;
      if (userTotal === 0) {
        let cnt = 0;
        divisionUserCnt.forEach((item) => {
          cnt += item.userCnt;
        });
        if (cnt > userTotal) {
          await this.setState({
            userTotal: cnt
          });
        }
      }
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### divisionUserCntSel error : ', e);
    } finally {
      // this.isLoadingBarChange(false);
    }
  };

  //부서별 사용자 조회
  divisionStaffSel = async (_orgCode) => {
    const { param } = this.state;
    const { text } = this.props;
    let orgCode = _orgCode;
    const params = {
      orgCode: orgCode,
      viewType: param.viewType
    };
    await this.staffSel(params);
    this.setState({
      param: update(this.state.param, { ['orgCode']: { $set: orgCode } }),
      staffCheckedData: []
      // , isChecked : false
    });
    $('.checkbox.pure input').prop('checked', false);

    this.isLoadingBarChange(false);
  };

  //식대그룹별 사용자 조회
  groupStaffList = async (group) => {
    const { param } = this.state;
    const { text } = this.props;

    let gIdx = group ? group.idx : null;
    const params = {
      groupid: gIdx,
      viewType: param.viewType
    };
    this.staffSel(params);

    this.setState({
      param: update(this.state.param, {
        ['groupid']: { $set: gIdx },
        ['orgCode']: { $set: null }
      }),
      staffCheckedData: []
    });
  };

  handleSubmit = () => {
    const { fn, auth, text } = this.props;
    const { param, groupid } = this.state;
    const params = {
      orgCode: param.orgCode,
      groupid: param.groupid,
      level: auth ? auth.value : null,
      keyword: text ? text.value : null,
      viewType: param.viewType
    };
    this.setState({
      param: update(this.state.param, {
        ['keyword']: { $set: params.keyword },
        ['level']: { $set: params.level }
      })
    });

    this.staffSel(params);
  };

  //검색
  handleEntSubmit = async (e) => {
    const { fn, auth } = this.props;
    const { param, groupid } = this.state;
    if (e.key === 'Enter') {
      let keyword = e.target.value;
      const params = {
        keyword: keyword,
        orgCode: param.orgCode,
        groupid: param.groupid,
        level: auth ? auth.value : null,
        viewType: param.viewType
      };

      this.setState({
        param: update(this.state.param, {
          ['keyword']: { $set: keyword },
          ['level']: { $set: params.level }
        })
      });

      this.staffSel(params);
    }
  };

  //사용자 체크박스 선택 on/off
  staffChecked = async (e, data, type) => {
    let isChecked = e.target.checked;
    let events = e.target;
    // const { param } = this.state;
    // const params = {
    //   keyword : param.keyword
    //   , orgCode : param.orgCode
    //   , groupid : param.groupid
    //   , level: param.level
    // };

    //전체 선택 on/off
    if (type === 'all') {
      this.isLoadingBarChange(true);
      // await this.staffSel(params);
      const { staffList } = this.props;
      const data = staffList ? staffList.data.user : null;
      // 전체 on/off 된 데이터 반환
      const staffCheckedData = cm.staffCheckedData(e, data, isChecked, 'all');

      this.setState({
        isChecked: isChecked,
        staffCheckedData: staffCheckedData
      });

      this.isLoadingBarChange(false);

      $('.staff-checkbox').prop('checked', isChecked);
    } else {
      this.setState((prevState, props) => {
        return {
          staffCheckedData: cm.staffCheckedData(events, prevState.staffCheckedData, isChecked, 'each')
        };
      });
    }
  };

  //사용자 부서, 식대그룹, 퇴사 bulk 완료
  bulkCompletionBtn = (type, reserveDate) => {
    const { staffCheckedData } = this.state;
    let id = [],
      value = null;

    //사용자 id
    staffCheckedData.forEach((data) => {
      id.push(data.id);
    });

    //부서 이동
    if (type === 'division') {
      const { depth } = this.props;

      if (depth.value) {
        value = depth.value;
      }

      //식대 그룹 이동
    } else if (type === 'group') {
      const { groupIdx } = this.props;
      value = groupIdx.value;

      //계정 탈퇴
    } else if (type === 'withdraw') {
      value = -5;

      //계정 일시정지
    } else if (type === 'pause') {
      value = -1;
      //계정 일시정지해제
    } else if (type === 'pauseCancel') {
      value = 1;
    }

    let params = {
      type: {
        key: type,
        value: value
      },
      user: {
        id: id
      },
      reserveDate
    };
    this.staffBulkMod(params);
  };

  staffBulkMod = async (params) => {
    try {
      await this.setState({
        isLoadingBar: true
      });

      const { cpAPI } = this.props;
      await cpAPI.staffBulkMod(params);
      window.location.reload();
    } catch (e) {
      const response = e.response;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### staffBulkMod error : ', e);
    } finally {
    }
  };

  movePage = (url) => {
    safeHistoryPush(this.context.router.history, url);
  };

  //탭 이동
  tabMove = async (type) => {
    await this.setState({
      tabType: type
    });

    this.groupStaffList(null);
  };

  //정보 변경 내역 조회
  changeInfoSel = async (params) => {
    const { cpAPI } = this.props;
    this.setState({ changeInfoParams: params });
    try {
      await cpAPI.changeInfoSel(params);
    } catch (e) {
      const response = e.response;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### changeInfoSel error : ', e);
    }
  };

  //정보 변경 내역 예약 취소
  cancelReserve = async (idx) => {
    const { cpAPI } = this.props;
    const { changeInfoParams } = this.state;
    try {
      await cpAPI.cancelReserveDel(idx);
      this.changeInfoSel(changeInfoParams);
    } catch (e) {
      const response = e.response;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### changeInfoSel error : ', e);
    }
  };

  render() {
    // const { staffList, company } = this.props;
    const { param, staffCheckedData, isLoadingBar, tabType, userTotal, userCnt } = this.state;
    const leftArea = {
      fn: {
        groupStaffList: this.groupStaffList,
        divisionStaffSel: this.divisionStaffSel,
        divisionMod: this.divisionMod,
        divisionDel: this.divisionDel,
        divisionAdd: this.divisionAdd,
        divisionUserCntSel: this.divisionUserCntSel,
        tabMove: this.tabMove,
        isLoadingBarChange: this.isLoadingBarChange
      },
      data: {
        param: param,
        tabType: tabType,
        userTotal: userTotal
      }
    };

    const rightArea = {
      fn: {
        staffSel: this.staffSel,
        handleEntSubmit: this.handleEntSubmit,
        staffChecked: this.staffChecked,
        isLoadingBarChange: this.isLoadingBarChange,
        handleSubmit: this.handleSubmit
      },
      data: {
        param: param,
        tabType: tabType,
        staffCheckedData: staffCheckedData,
        userCnt: userCnt
        // , isLoadingBar: isLoadingBar
      }
    };

    const bottomBtnArea = {
      data: {
        staffCheckedData: staffCheckedData
      },
      fn: {
        movePage: this.movePage,
        positionDel: this.positionDel,
        positionAdd: this.positionAdd,
        positionMod: this.positionMod,
        bulkCompletionBtn: this.bulkCompletionBtn,
        changeInfoSel: this.changeInfoSel,
        cancelReserve: this.cancelReserve
      }
    };

    return (
      <main className="sm" style={{ overflow: 'inherit' }}>
        {isLoadingBar ? <Commons.LoadingBar /> : null}
        <Grid columns="equal" style={{ paddingLeft: '1px', margin: 0 }}>
          <Grid.Row style={{ minHeight: 'calc(100vh - 190px)' }}>
            <ManagementMeal.LeftArea fn={leftArea.fn} data={leftArea.data} />
            <ManagementMeal.RightArea staffCheckedDatadd={staffCheckedData} fn={rightArea.fn} data={rightArea.data} />
          </Grid.Row>
        </Grid>
      </main>
    );
  }
}

StaffManagementMeal.propTypes = propTypes;
StaffManagementMeal.defaultProps = defaultProps;

StaffManagementMeal.contextTypes = {
  router: PropTypes.object.isRequired
};

StaffManagementMeal = connect(
  (state) => ({
    staffDivisionList: state.commons.staffDivision,
    staffList: state.commons.staff,
    depth: state.commons.depth,
    groupIdx: state.commons.group,
    divisionUserCnt: state.company.divisionUserCnt, //부서별 사용자 수(카운트)
    auth: state.commons.auth,
    text: state.commons.text
  }),
  (dispatch) => ({
    cpAPI: bindActionCreators(
      {
        positionSel: cp_action.PositionSel,
        positionAdd: cp_action.PositionAdd,
        positionMod: cp_action.PositionMod,
        positionDel: cp_action.PositionDel,
        staffBulkMod: cp_action.StaffBulkMod,
        divisionMod: cp_action.DivisionSortMod,
        divisionDel: cp_action.DivisionDel,
        divisionAdd: cp_action.DivisionAdd,
        divisionUserCntSel: cp_action.DivisionUserCnt,
        changeInfoSel: cp_action.ChangeInfoSel,
        cancelReserveDel: cp_action.CancelReserve
      },
      dispatch
    ),

    cmAPI: bindActionCreators(
      {
        sikdaeGroupSel: cm_action.SikdaeGroupList,
        staffSel: cm_action.StaffSel,
        staffDivisionSel: cm_action.StaffDivisionList
      },
      dispatch
    )
  })
)(StaffManagementMeal);

export default StaffManagementMeal;
